import { FlagComponent } from '@cmg/common';
import React, { VFC } from 'react';

type Props = {
  readonly countryCode?: string | null;
};

export const Flag: VFC<Props> = ({ countryCode }) => {
  return countryCode ? (
    <FlagComponent countryCode={countryCode} countryDisplayName={countryCode} />
  ) : null;
};
